module.exports = __webpack_public_path__ + "static/media/kitty-pryde-win.11a5950a.png";